<div class="alerts-container">
  <div *ngFor="let alert of alerts" class="apps-alert">
    <span>{{alert?.Message}}</span>
  </div>
</div>